<template lang="pug">
.meter
  .meter__bar(:style="showMeterValue()" :class="showAlert()")
</template>

<script>
export default {
  name: 'Meter',
  props: ['val1', 'val2'],
  data() {
    return {
      min: '',
      max: '',
    };
  },
  watch: {
    val1(newVal, oldVal) {
      this.min = newVal;
    },
    val2(newVal, oldVal) {
      this.max = newVal;
    },
  },
  methods: {
    showAlert() {
      if (this.max === null) {
        return false;
      }
      if ((this.min / this.max) >= 1) {
        return 'alert';
      }
      if ((this.val1 / this.val2) > 0.8) {
        return 'warning';
      }
      return false;
    },
    showMeterValue() {
      const meter = (this.min / this.max) * 100;
      if (!meter) {
        return { 'width': '0%' };
      } else {
        return { 'width': meter + '%' };
      }
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/Meter.vue